// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__gEZII","left":"StickyBox_left__23Mlg","right":"StickyBox_right__1FGQM"};